import services from './../../../services/service'; // Service Class
let service = new services();

export default {
    name: 'Account',
    data () {
        return {
            user: {},
            sellpoints:{},
            img_url: service.imageURL,
            user_business_interests: {},
            user_details:{}
        }
    },
    components: {
        
     },
    methods: {
        setComponent(attr1,attr2){

        },

        setUserComponent(attr1,attr2,attr3){
            this.deactivate_processing();
            this.user_details = {};
            this.user_details[component] = true;
        },

        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                           // this.user.user_id = element.user_id;
                            //special case for profile
                            service.getUser(this, element.user_id).then(data => {
                                if(data.body.status == 200) {
                                    this.user = data.body.data;
                                     //get sellpoints
                                    this.getSellpoints(element.user_id);

                                    //get Users Interests
                                    this.getUserBusinessInterests(element.user_id);
                                }
                            }).catch((err) => {
                                if(err) {
                                    toastr.error('Sorry, could not process information', 'Warning!');
                                }
                            })
                         //../special case for profile
                         }, this);
                    }else {
                       this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        //console.log(err)
                        this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
        },

    
        getSellpoints(user){
            service.getBusinesses(this, user).then(data => {
                if(data.body.status == 200) {
                    this.sellpoints = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                   //log it
                   console.log(err)
                }
            })
        },

        getUserBusinessInterests(user){
            service.getUserBusinessInterests(this, user).then(data => {
                if(data.body.status == 200) {
                    this.user_business_interests = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                   //log it
                   console.log(err)
                }
            })
        },

        editProfile(){
            this.activate_processing();
            var credentials = {
                user_name: this.user.user_name,
                user_phone: this.user.user_phone,
                user_email: this.user.user_email
            }
            
            let navi = this.$router;

            //test data
            let data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email_test = re.test(String(this.user.user_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            let phone_test = re_phone.test(String(this.user.user_phone).toLowerCase());
            if((email_test == false) || (this.user.user_name == " ") || (phone_test == false)){
                data_test = false;
                this.data_processing_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            }else{
                data_test = true;
                this.data_processing_message = "";
            }
            if(data_test){
                if(credentials.user_name != null && credentials.user_phone != null) {
                    service.editUser(this, credentials).then(function(data) {
                        if(data.body.status == 201) {
                            this.user = data.body_data;
                            this.user_details = {};
                        }else{
                            this.data_processing_message = "Sorry could not save data, please try again";
                            this.deactivate_processing();   
                        }
                    }).catch((err) => {
                        this.data_processing_message = "Sorry could not save data, please try again";
                        this.deactivate_processing();
                    })
                }
            }
                    
        },

        changePassword(){},

        changeEmail(){},



    },
    created: function(){
        document.title = "Account" + " | SP";
        this.preset();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Buypoint/Account/script.js